
    <ng-container *ngIf="params.data.assignees?.length; else noData">
      <ng-container *ngIf="params.data.assignees.length > 1; else showNames">
        <app-user-icon-list
          [usersList]="params.data.assignees.length"
          [imageList]="params.data.assignees"
          [isGridCell]="params.eGridCell ? true : false">
        </app-user-icon-list>
      </ng-container>

      <ng-template #showNames>
        <div class="user-profiles">
          <div class="user" *ngFor="let user of params.data.assignees">
            <img
              [src]="user?.profilepicture || fallbackImage"
              class="user-avatar"
            />
            <span class="user-name">{{ user?.username }}</span>
          </div>
        </div>
      </ng-template>
    </ng-container>

    <ng-template #noData>
        <img
            [src]="fallbackImage"
            class="user-avatar"
        />
      <span class="space-between-img">Unassigned</span>
    </ng-template>
  